export default "__VITE_ASSET___EHWRTMQ__"